import type { SupportedLanguage } from '@plato/app-meta/locale';
import { deTranslations } from './de.ts';
import { enTranslations } from './en.ts';
import { frTranslations } from './fr.ts';

declare module 'i18next' {
    // eslint-disable-next-line @typescript-eslint/consistent-type-definitions -- We need interface merging here
    interface CustomTypeOptions {
        defaultNS: 'common';
        // half-strict types: we don't check the keys for now; only NS
        resources: Record<TranslationNamespace, Record<string, string>>;
    }
}

export type TranslationNamespace = keyof typeof deTranslations;

export const resources = {
    de: deTranslations,
    en: enTranslations,
    fr: frTranslations,
} satisfies Record<SupportedLanguage, Record<TranslationNamespace, unknown>>;
